export const wayMoreFormsSelector = (state, searchTerm = '') =>
  state.waymore.forms.data.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );
